import React, { Component } from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
import { Add, Delete, Edit, PlaylistAdd } from "@material-ui/icons";
import { Link } from 'react-router-dom';
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import datatablesSelectableStyle from 'assets/jss/material-dashboard-pro-react/datatablesSelectableStyle';
import Button from "components/CustomButtons/Button.jsx";
import AccountImage from '../../components/Image/AccountImage';
import { IconButton, Tooltip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faMoneyBill, faCalendar, faBolt } from '@fortawesome/pro-solid-svg-icons';
import { store } from '../../redux/store';
import { push } from 'connected-react-router';
import DataTable from '../../components/Table/DataTable';
import CurrencyText from '../../components/TextHover/CurrencyText';
import moment from 'moment';
import AddModal from './PricingModals/AddModal';
import AddBulkModal from './PricingModals/AddBulkModal';
import DeleteModal from './PricingModals/DeleteModal';
import SetPriceModal from './PricingModals/SetPriceModal';
import SmallModal from '../../components/Modal/SmallModal';

import Api from 'api/index.js';
import ProvisioningEndpoints from 'api/ProvisioningEndpoints';
import Loading from '../../components/Loading/Loading';

const decideBillCycle = (bill_cycle) => {
    switch (bill_cycle) {
        case "transaction":
            return <FontAwesomeIcon icon={faMoneyBill} />;
        case "subscription":
            return <FontAwesomeIcon icon={faCalendar} />;
        case "adhoc":
        case "temporary":
            return <FontAwesomeIcon icon={faBolt} />;
    }
}

class Pricing extends Component {
    constructor(props) {
        super(props)
    }

    columns = [
        {
            name: 'id',
            options: {
                filter: false,
                sort: false,
                download: false,
                print: false,
                display: "excluded"
            }
        },
        {
            name: "Bill Cycle",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRender: value => decideBillCycle(value)
            }
        },
        {
            name: 'Service',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: 'Stock Code',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: 'Reference',
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: 'currency',
            options: {
                filter: false,
                sort: false,
                download: false,
                print: false,
                display: "excluded"
            }
        },
        {
            name: 'Price',
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value, tableMeta) => <CurrencyText currency={tableMeta.rowData[5]} value={value} popoverStyle={{ marginTop: -20 }} />
            }
        },
        {
            name: 'Period',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => `${moment(value).format("MMMM YYYY")}${tableMeta.rowData[8] ? " -> " + moment(tableMeta.rowData[8]).format("MMMM YYYY") : " to date"}`
            }
        },
        {
            name: 'end',
            options: {
                filter: false,
                sort: false,
                download: false,
                print: false,
                display: "excluded"
            }
        }
    ];

    state = {
        addDialog: false,
        addBulkDialog: false,
        deleteDialog: false,
        setPriceDialog: false,

        selectedPriceIds: []
    };

    refresh = () => this.props.refresh();

    deleteSelected() {
        Api.post(ProvisioningEndpoints.delete, { ids: this.state.selectedPriceIds })
            .then(({ data }) => {
                this.refresh();
            })
            .catch(e => {
                console.error(e);
                this.refresh();
            });
    }

    render() {
        const { classes, account } = this.props;

        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', position: 'relative' }}>
                <IconButton component={Link} to={'/products/view/' + this.props.product_id} style={{ position: 'absolute', top: 0, left: 0 }}>
                    <FontAwesomeIcon icon={faArrowAltCircleLeft} size="2x" />
                </IconButton>

                <div style={{ height: 180, padding: 15, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <AccountImage {...account} accountSize={90} companySize={28} />
                    <span style={{ paddingTop: 10, fontSize: 17, fontWeight: '400' }}>{account.account_no}</span>
                    <span style={{ paddingTop: 4, textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{account.name}</span>
                </div>
                <div>
                    <DataTable
                        title={"Pricing"}
                        data={
                            this.props.pricingList.map(
                                pricing =>
                                    [
                                        pricing.id,
                                        pricing.bill_cycle,
                                        pricing.service.name,
                                        pricing.service.stock_code,
                                        pricing.product_reference,
                                        pricing.currency,
                                        pricing.price,
                                        pricing.start,
                                        pricing.end
                                    ]
                            )
                        }
                        columns={this.columns}
                        options={{
                            selectableRows: 'multiple',
                            customToolbarSelect: (selectedRows, displayData, setSelectedData) => {
                                var newSelectedPrices = null;
                                try {
                                    newSelectedPrices = selectedRows.data.map(x => displayData[x.index].data[0]);
                                } catch (e) {
                                    console.warn(selectedRows, displayData);
                                }

                                if(newSelectedPrices === null) {
                                    return <Loading />;
                                }

                                return (
                                    <div>
                                        <Tooltip title="Set Price">
                                            <IconButton onClick={() => this.setState({ setPriceDialog: true, selectedPriceIds: newSelectedPrices })}>
                                                <Edit />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                            <IconButton onClick={() => this.setState({ deleteDialog: true, selectedPriceIds: newSelectedPrices })}>
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                );
                            },
                            customToolbar: () => {
                                return [
                                    <Tooltip key="add_single" title="Add Price">
                                        <IconButton onClick={() => this.setState({ addDialog: true })}>
                                            <Add />
                                        </IconButton>
                                    </Tooltip>,
                                    <Tooltip key="add_multiple" title="Add Bulk Prices">
                                        <IconButton onClick={() => this.setState({ addBulkDialog: true })}>
                                            <PlaylistAdd />
                                        </IconButton>
                                    </Tooltip>
                                ];
                            }
                        }}
                        themeStyle={datatablesSelectableStyle}
                    />
                </div>

                {/* Modals */}
                <AddModal
                    isOpen={this.state.addDialog}
                    close={() => this.setState({ addDialog: !this.state.addDialog })}
                    services={this.props.services}
                    refresh={() => this.refresh()}
                    product_id={this.props.product_id}
                    customer_id={this.props.account.id}
                />
                <AddBulkModal
                    isOpen={this.state.addBulkDialog}
                    close={() => this.setState({ addBulkDialog: !this.state.addBulkDialog })}
                    services={this.props.services}
                    refresh={() => this.refresh()}
                    product_id={this.props.product_id}
                    customer_id={this.props.account.id}
                />
                <SmallModal
                    id="delete"
                    isOpen={this.state.deleteDialog}
                    accept={() => this.setState({ deleteDialog: false }, () => {
                        this.deleteSelected(); 
                        //this.refresh();
                    })}
                    close={() => this.setState({ deleteDialog: !this.state.deleteDialog })}>
                    Are you sure you want to <span style={{ color: 'var(--danger)' }}>delete</span> {this.state.selectedPriceIds.length > 1 ? "these prices" : "this price"}?
                </SmallModal>
                <SetPriceModal
                    isOpen={this.state.setPriceDialog}
                    close={() => this.setState({ setPriceDialog: !this.state.setPriceDialog })}
                    selectedIds={this.state.selectedPriceIds}
                    refresh={() => this.refresh()}
                />
            </div>
        )
    }
}

export default withStyles(buttonsStyle)(Pricing);
